import { Inject, Injectable } from '@angular/core';
import { Client, IMessage } from '@stomp/stompjs';
import { OAuthService } from 'angular-oauth2-oidc';
import { filter, Observable, Subject } from 'rxjs';
import { LocalStorageManagementService } from '../local-storage-management/local-storage-management.service';
import { NotificationService } from '../notifications-service/notification.service';

@Injectable({
  providedIn: 'root'
})
export class NotifyWsService {

  private stompClient: Client;
  private messageSubject: Subject<any> = new Subject<any>();

  // Dos tópicos distintos
  private topicNotificaciones: string;
  private topicEventosCamara: string;

  constructor(
    @Inject('environment') private environment: any,
    private localStorageManagementService: LocalStorageManagementService,
    private oauthService: OAuthService,
    private notificationService: NotificationService
  ) {
    // this.subscribeToTokenRefresh();
  }

  // initWebSocketConnect() {
  //   this.connectWebSocket();
  // }

  // connectWebSocket() {
  //   try {
  //     const token = this.localStorageManagementService.getUserLocalStorage();

  //     let accontUserId = '';
  //     this.localStorageManagementService.userInfo$.subscribe(
  //       (res) => (accontUserId = res?.id)
  //     );

  //     const brokerURL = `${this.environment.wsAlertsUrl}/?access_token=${token}`;
  //     this.topicNotificaciones = `/api/v1/notification/subscribe/user/${accontUserId}`;
  //     this.topicEventosCamara = `/api/v1/camera-events/subscribe/user/${accontUserId}`;

  //     if (!this.stompClient) {
  //       this.stompClient = new Client({
  //         brokerURL: brokerURL,
  //         connectHeaders: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //         reconnectDelay: 5000,
  //         heartbeatIncoming: 4000,
  //         heartbeatOutgoing: 4000
  //       });

  //       this.stompClient.onConnect = () => {
  //         // this.subscribeToTopic(this.topicNotificaciones); //TODO uncomment
  //         // this.subscribeToTopic(this.topicEventosCamara);
  //       };

  //     } else {
  //       this.stompClient.brokerURL = brokerURL;
  //       if (this.stompClient.connected) {
  //         this.stompClient.deactivate().then(() => {
  //           this.stompClient.activate();
  //         });
  //       } else {
  //         this.stompClient.activate();
  //       }
  //     }

  //     this.stompClient.activate();

  //   } catch (error) {
  //     console.error('error WS: ', error);
  //   }
  // }

  // private subscribeToTokenRefresh() {
  //   this.oauthService.events
  //     .pipe(filter(e => e.type === 'token_received'))
  //     .subscribe(() => {
  //       this.connectWebSocket();
  //     });
  // }

  subscribeToTopic(topic: string) {
    // this.stompClient.subscribe(topic, (message: IMessage) => {
    //   let type = '';
    //   const msg = JSON.parse(message.body);

    //   if (topic.includes('notification')) {
    //     type = 'notification';
    //     this.notificationService.increaseNotificationStatus();
    //   } else if (topic.includes('camera-events')) {
    //     type = 'camera-events';
    //     this.notificationService.increaseNotificationStatus();
    //   }

    //   this.messageSubject.next({ data: msg, type });
    // });
  }

  getMessage(): Observable<any> {
    return this.messageSubject.asObservable();
  }
}
